/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useState, memo, useEffect } from 'react'
import ErrorMessage from '../ErrorMessage'

export default memo(function FloatingInput(props) {
    const { setsubmitSelected,
        submitSelected,
        value,
        inputType,
        id,
        handleInput,
        state,
        classKey,
        labelCalss,
        errorImage,
        normalImage,
        isPassword,
        errorState,
        floatingImage,
        reference,
        optional,
        placeholder,
        disabled,
        maxLength,
        text } = props
    const [type, settype] = useState('text');
    useEffect(() => {
        settype('password')
    }, [submitSelected])
    return (
        <>
            <input
                id={id}
                type={inputType ? inputType : isPassword ? type : 'text'}
                ref={reference}
                data-testid={id}
                value={value}
                onFocus={() => setsubmitSelected(false)}
                placeholder={placeholder || ''}
                onChange={(e) => {
                    if (maxLength && e.target.value.length > maxLength) {
                        return;
                    }
                    handleInput(id, e.target.value)
                }}
                maxLength={maxLength}
                disabled={disabled}
                autoComplete='off'
                className={classKey} />
            <label htmlFor={id} class={labelCalss}>{text}</label>

            {floatingImage && <button type="button" className={`cursor-pointer absolute ${optional === undefined && submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) ? 'top-[32%]' : 'top-[50%]'}  -translate-y-[50%] right-3.5`}>
                {/* {isPassword ? <>{type === 'text' ?
                    <img loading="lazy" src="/assets/images/eye-open.svg" alt="password-show" className="password-show" onClick={() => settype('password')} />
                    : <img loading="lazy" src={`/assets/images/${submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) ? 'eye-error.svg' : 'eye.svg'}`} alt="password-hide" className="password-show" onClick={() => settype('text')} />}</> : <img loading="lazy" src={`/assets/images/${submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) ? `${errorImage}` : `${normalImage}`}`} alt="password-show" className="password-show" />
                } */}

            </button>}
            {optional === undefined && submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) && <ErrorMessage error message={errorState[id] || 'This field is mandatory'} classKey='itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err' />}

        </>
    )
})
